import _ from "lodash";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import { createAdvertiser, deleteAdvertiser } from "../../firebase";
import { ApiRequest } from "../../firebase/server";
import { fetchAdvertisers } from "../../actions";
import {
  Grid,
  Menu,
  Form,
  Segment,
  Button,
  Header,
  Icon,
  Message,
} from "semantic-ui-react";

const GamAdvertisers = ({ retailer }) => {
  const dispatch = useDispatch();

  const advertisers = useSelector((state) => state.advertisers);

  const [suppliers, setSuppliers] = useState([]);
  const [supplierOption, setSupplierOption] = useState({});
  const [showMessage, setShowMessage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [advertisersTotal, setAdvertisersTotal] = useState();

  useEffect(() => {
    setLoading(true);
    setShowMessage({
      color: "yellow",
      content: "Fetching advertisers from Google Ad Manager",
    });
    ApiRequest({
      retailer,
      service: "gam",
      call: "getAdvertisers",
    }).then(
      (results) => {
        const advertiserList = results.result;
        setSuppliers(advertiserList);
        setLoading(false);
        setShowMessage(null);
      },
      (error) => {
        console.log("error returned from api", error);
        setShowMessage({
          color: "red",
          content: "Unable to fetch advertisers from Google Ad Manager",
        });
        setSuppliers([]);
        setLoading(false);
      }
    );
  }, [retailer]);

  useEffect(() => {
    setAdvertisersTotal(advertisers.length);
    console.log("advertisers", advertisers);
  }, [advertisers]);

  const checkAdvertiser = (id) => {
    return new Promise(async (resolve, reject) => {
      const exists = await _.find(advertisers, (item) => {
        return item.advertiserId === id;
      });
      if (exists) {
        return reject("advertiser already exists");
      } else {
        return resolve();
      }
    });
  };

  const handleDelete = (id) => {
    let agree = window.confirm(
      `Are you sure you want to delete ${advertisers[id].displayName}`
    );
    if (agree) {
      deleteAdvertiser(advertisers, id, retailer).then((data) => {
        dispatch(fetchAdvertisers(data));
      });
    }
  };

  const handleChange = (e) => {
    let index = e.nativeEvent.target.selectedIndex;
    let displayName = e.nativeEvent.target[index].text;
    let advertiserId = e.target.value;
    setSupplierOption({ displayName, advertiserId });
    setShowMessage(null);
  };

  const handleSubmit = () => {
    setLoading(true);
    if (supplierOption.advertiserId) {
      checkAdvertiser(supplierOption.advertiserId)
        .then(() => {
          let list = [...advertisers, supplierOption];
          createAdvertiser({ advertisers: list }, retailer).then(() => {
            setShowMessage({
              color: "green",
              content: `${supplierOption.displayName} was added`,
            });
            setLoading(false);
          });
        })
        .catch((error) => {
          setShowMessage({
            color: "red",
            content: `${supplierOption.displayName} already exists`,
          });
          setLoading(false);
        });
    } else {
      setShowMessage({ color: "orange", content: "Choose a supplier" });
      setLoading(false);
    }
  };

  const SupplierList = () => {
    return suppliers.map((supplier) => {
      return (
        <option
          name={supplier.displayName}
          key={supplier.advertiserId}
          value={supplier.advertiserId}
        >
          {supplier.displayName}
        </option>
      );
    });
  };

  const AdvertiserList = () => {
    return (
      <TransitionGroup className="adlist">
        {advertisers.map((advertiser, index) => (
          <CSSTransition
            key={advertiser.advertiserId}
            timeout={500}
            classNames="item"
          >
            <Menu.Item name={advertiser.displayName}>
              {advertiser.displayName}
              <Icon
                size="large"
                color="red"
                name="trash"
                className="pointer"
                onClick={() => handleDelete(index)}
              />
            </Menu.Item>
          </CSSTransition>
        ))}
      </TransitionGroup>
    );
  };

  return (
    <Grid columns={2}>
      <Grid.Column>
        <Segment>
          <Form onSubmit={handleSubmit}>
            <Header as="h3">Choose a supplier</Header>
            <Form.Field>
              <select
                onChange={handleChange}
                className="ui selection dropdown"
                value={supplierOption.advertiserId}
              >
                <SupplierList />
              </select>
            </Form.Field>
            <Button
              positive
              size="tiny"
              loading={loading}
              disabled={loading || suppliers.length < 1}
            >
              Submit
            </Button>
            {showMessage && (
              <Message
                color={showMessage.color}
                content={showMessage.content}
                onDismiss={() => setShowMessage(null)}
              />
            )}
          </Form>
        </Segment>
      </Grid.Column>
      <Grid.Column>
        <Segment>
          <Header as="h3">Advertisers ({advertisersTotal})</Header>
          <Menu vertical className="advlist">
            <AdvertiserList />
          </Menu>
        </Segment>
      </Grid.Column>
    </Grid>
  );
};

export default GamAdvertisers;
